module.exports = __webpack_public_path__ + "assets/img/role_menpai_name-a4e9958b.png";